import DeleteFile from './DeleteFile';

export default DeleteFile;
